import { render } from "./send-now-watercooler.vue?vue&type=template&id=5b76ccae&lang=pug"
import script from "./send-now-watercooler.vue?vue&type=script&lang=js"
export * from "./send-now-watercooler.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__